export const sarSubjectIdentificationTypes = [
  { label: "Driver's license/State ID", value: "Driver's license/State ID" },
  { label: 'Passport', value: 'Passport' },
  { label: 'Alien registration', value: 'Alien registration' },
  { label: 'Other', value: 'Other' }
]
